import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Blank from '../../hoc/Blank/Blank';
import Table from '../../components/UI/Table/Table';
import Spinner from '../../components/UI/Spinner/Spinner';
import * as actions from '../../store/actions/index';
import 'react-toastify/dist/ReactToastify.min.css';
import { ToastContainer, toast } from 'react-toastify';

let deleting = false;
let orderId = 0;
class PickupSummary extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.onFetchPickupSummary();
  }

  componentDidUpdate(prevProps) {
    if (this.props.pickupCreated) {
      let message = "The add pickup was successfully added.";
      if (!this.state.pickupCreated || this.state.pickupCreated != this.props.pickupCreated  ) {
        this.setState({pickupCreated:this.props.pickupCreated});
        this.props.onLoadResult('pickupCreated',false);
        toast(message);
      }
    }
  }

  showUser = (e) => {
    this.setState({pickupCreated:false});
    let oid = e.currentTarget.getAttribute('oid');
    this.props.history.push('/adminPickup?' + oid);
  }

  state = {
    userId: 0,
    pickupCreated: false
  }



  render() {
    if (!this.props.loading && this.props.pickupSummary) {
      var data = [];
      let pl = "30px";
      let fifty = "50px";
      let oneFifty = "150px";
      let seventyFive = "75px";

      if (window.innerWidth < 500) {
        pl = "5px";
        fifty = "40px";
        oneFifty = "100px";
        seventyFive = "50px";
      }
 
      let i = -1;
     
      for (let k in this.props.pickupSummary) {
        let sum = this.props.pickupSummary[k];
        let rem = sum.hardwoodBagsRemaining + sum.cedarBagsRemaining +
        sum.blackBagsRemaining + sum.redBagsRemaining;
        if (rem > 0) {
          i = i + 1;
          data.push({
            oid: sum.userId, data: [{
              value: sum.userId,
              style: { paddingLeft: pl, width: seventyFive },
              full: false
            },
            {
              value: sum.scout,
              style: { width: oneFifty, paddingLeft: pl },
              full: false
            }
            
            ]
          }
          )

          if (this.props.mulchYear.sellHardwood) {
            data[i].data.push(
              {
                value: sum.hardwoodBags,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }
            );
          }
          if (this.props.mulchYear.sellCedar) {
            data[i].data.push(
              {
                value: sum.cedarBags,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }    
            );
          }
          if (this.props.mulchYear.sellBlack) {
            data[i].data.push(
              {
                value: sum.blackBags,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }
            );
          }
          if (this.props.mulchYear.sellRed) {
            data[i].data.push(
              {
                value: sum.redBags,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }
            );
          }
          if (this.props.mulchYear.sellHardwood) {
            data[i].data.push(
              {
                value: sum.hardwoodBagsTaken,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }
            );
          }
          if (this.props.mulchYear.sellCedar) {
            data[i].data.push(
              {
                value: sum.cedarBagsTaken,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }    
            );
          }
          if (this.props.mulchYear.sellBlack) {
            data[i].data.push(
              {
                value: sum.blackBagsTaken,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }
            );
          }
          if (this.props.mulchYear.sellRed) {
            data[i].data.push(
              {
                value: sum.redBagsTaken,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }
            );
          }
          if (this.props.mulchYear.sellHardwood) {
            data[i].data.push(
              {
                value: sum.hardwoodBagsRemaining,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }
            );
          }
          if (this.props.mulchYear.sellCedar) {
            data[i].data.push(
              {
                value: sum.cedarBagsRemaining,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }    
            );
          }
          if (this.props.mulchYear.sellBlack) {
            data[i].data.push(
              {
                value: sum.blackBagsRemaining,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }
            );
          }
          if (this.props.mulchYear.sellRed) {
            data[i].data.push(
              {
                value: sum.redBagsRemaining,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }
            );
          }
          data[i].data.push(
            {
              value: rem,
              style: { width: fifty, paddingLeft: pl },
              full: false
            }
          );
        }
      }


      var header = [{
        name: "User Id",
        sort: "",
        style: { paddingLeft: pl, width: seventyFive }
      },
      {
        name: "Scout",
        sort: "",
        style: { width: oneFifty, paddingLeft: pl }
      }
    ];

    if (this.props.mulchYear.sellHardwood) {
      header.push(
      {
        name: "Hwd",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellCedar) {
      header.push(
      {
        name: "Cdr",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellBlack) {
      header.push(
      {
        name: "Blk",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellRed) {
      header.push(
      {
        name: "Red",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellHardwood) {
        header.push(
        {
          name: "Hwd Tkn",
          style: { width: fifty, paddingLeft: pl }
        })
      }
  
      if (this.props.mulchYear.sellCedar) {
        header.push(
        {
          name: "Cdr Tkn",
          style: { width: fifty, paddingLeft: pl }
        })
      }
  
      if (this.props.mulchYear.sellBlack) {
        header.push(
        {
          name: "Blk Tkn",
          style: { width: fifty, paddingLeft: pl }
        })
      }
  
      if (this.props.mulchYear.sellRed) {
        header.push(
        {
          name: "Red Tkn",
          style: { width: fifty, paddingLeft: pl }
        })
      }

      if (this.props.mulchYear.sellHardwood) {
        header.push(
        {
          name: "Hwd Left",
          style: { width: fifty, paddingLeft: pl }
        })
      }
  
      if (this.props.mulchYear.sellCedar) {
        header.push(
        {
          name: "Cdr Left",
          style: { width: fifty, paddingLeft: pl }
        })
      }
  
      if (this.props.mulchYear.sellBlack) {
        header.push(
        {
          name: "Blk Left",
          style: { width: fifty, paddingLeft: pl }
        })
      }
  
      if (this.props.mulchYear.sellRed) {
        header.push(
        {
          name: "Red Left",
          style: { width: fifty, paddingLeft: pl }
        })
      }

      header.push(
        {
          name: "Total Left",
          style: { width: fifty, paddingLeft: pl }
        })

      return (

        <Blank>
          <ToastContainer autoClose={3000} />
          <Table header={header} data={data} editPopupHandler={this.showUser}></Table>
        </Blank>
      );
    }
    else {
      return (
        <div>
          <Spinner />
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    mulchYear: state.orders.mulchYear,
    pickupSummary: state.orders.pickupSummary,
    pickupCreated: state.orders.pickupCreated
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchPickupSummary: () => dispatch(actions.fetchPickupSummary()),
    onLoadResult: (item,result) => dispatch(actions.loadResult(item,result))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PickupSummary);


// WEBPACK FOOTER //
// ./src/containers/PickupSummary/PickupSummary.js